export const trainingProgrammes = [
  {
    code: "FSD",
    name: "Factory Skills Development",
    description:
      "Industry-oriented training with practical factory exposure and a belt-based progression system, building technical capability on the factory floor.",
    icon: "ri-building-line",
    link: "https://training.textiletoday.com.bd/factory-skills-development-programs/",
  },
  {
    code: "PSD",
    name: "Professional Skills Development",
    description:
      "Advanced professional training focused on leadership, management and technical excellence for industry professionals.",
    icon: "ri-briefcase-2-line",
    link: "https://training.textiletoday.com.bd/professional-skill-development-programs/",
  },
  {
    code: "IBB",
    name: "Innovation Black Belt",
    description:
      "Extensive training combined with hands-on industry problem solving, developing innovation leaders who can drive real transformation.",
    icon: "ri-medal-line",
    link: "https://training.textiletoday.com.bd/innovation-black-belt/",
  },
  {
    code: "IP",
    name: "InternPro",
    description:
      "Structured internship and early-career development programme connecting emerging talent with industry opportunities.",
    icon: "ri-user-add-line",
    logo: "https://storage.helloreaddy.io/project_files/3695ba64-190a-4f8e-a9e2-04b761fa00c1/aea445b9-9780-4648-aeba-155a9546a445_compressed_Screenshot_207.webp",
    link: "https://training.textiletoday.com.bd/course/intern-pro/",
  },
  {
    code: "FLW",
    name: "Factory-Level Workshops",
    description:
      "Targeted on-site workshops addressing specific factory needs, from productivity improvement to quality management and lean manufacturing.",
    icon: "ri-tools-line",
  },
];